import ManagerBaseDashboard from '../views/ManagerBase/ManagerBaseDashboard';
import ManagerBaseSettings from '../views/ManagerBase/ManagerBaseSettings';

import ManagerBasePipelines from '../views/ManagerBase/ManagerBasePipelines';
import ManagerBaseCandidates from '../views/ManagerBase/ManagerBaseCandidates';

import ManagerBaseJobs from '../views/ManagerBase/ManagerBaseJobs';
import ManagerJobItem from '../components/Manager/Jobs/ManagerJobItem';

// import AdminBaseEmployers from '../views/AdminBase/AdminBaseEmployers';
// import AdminBaseReviewJobs from '../views/AdminBase/AdminBaseReviewJobs';
// import AdminBaseReviewApplications from '../views/AdminBase/AdminBaseReviewApplications';

import ManagerCandidateItem from '../components/Manager/Candidates/ManagerCandidateItem.vue';

// import EmployersItem from '../components/Admin/Employers/EmployersItem';
// import JobItem from '@/components/Admin/Jobs/JobItem';

import ManagerBaseProfile from '../views/ManagerBase/ManagerBaseProfile.vue';
import EmptyRouterView from '../router/EmptyRouterView';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/manager/user',
    name: 'manager-user',
    redirect: url_prefix + '/manager/dashboard',
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/manager/user/profile',
    name: 'manager-user-profile',
    component: ManagerBaseProfile,
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/manager/user/settings',
    name: 'manager-user-settings',
    component: ManagerBaseSettings,
    meta: { adminAuth: false, requiresAuth: true, managerAuth: true },
  },

  {
    path: '/manager/user/dashboard',
    name: 'manager-user-dashboard',
    component: ManagerBaseDashboard,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      breadcrumb: 'Dashboard',
    },
  },
  {
    path: '/manager/user/pipelines',
    name: 'manager-user-pipelines',
    component: ManagerBasePipelines,
    meta: {
      requiresAuth: true,
      managerAuth: true,

      breadcrumb: function() {
        //const { name } = this.$route;
        return 'Pipelines';
      },
    },
  },
  // MANAGER/Candidates
  {
    path: '/manager/user',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
    children: [
      {
        path: '/manager/user/candidates',
        name: 'manager-user-candidates',
        component: ManagerBaseCandidates,
        meta: {
          requiresAuth: true,
          managerAuth: true,
          breadcrumb: 'Candidates',
        },
      },
      {
        path: '/manager/user/candidates',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          managerAuth: true,
          breadcrumb: '',
        },
        children: [
          {
            path: '/manager/user/candidates/:manager_user_candidate_id',
            name: 'manager_user_candidate_id',
            component: ManagerCandidateItem,
            meta: {
              requiresAuth: true,
              managerAuth: true,

              /* breadcrumb: function() {
                return `${this.$store.getters.getCandidateById.first_name} ${this.$store.getters.getCandidateById.last_name}`;
              }, */
            },
          },
        ],
      },
    ],
  },
  // MANAGER/Jobs
  {
    path: '/manager/user',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
    },
    children: [
      {
        path: '/manager/user/jobs',
        name: 'manager-user-jobs',
        component: ManagerBaseJobs,

        meta: {
          requiresAuth: true,
          managerAuth: true,
          userAuth: true,
          breadcrumb: 'Jobs',
        },
      },
      {
        path: '/manager/user/jobs',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          managerAuth: true,
          userAuth: false,
          breadcrumb: '',
        },
        children: [
          {
            path: '/manager/user/jobs/:manager_user_job_uuid',
            name: 'manager_user_job_uuid',
            component: ManagerJobItem,
            meta: {
              requiresAuth: true,
              managerAuth: true,
              userAuth: false,
              breadcrumb: function() {
                return '';
                // return this.$store.getters.getJobAdById.title;
              },
            },
          },
        ],
      },
    ],
  },

  // Manager Review
  /* {
    path: url_prefix + '/manager/user/review/jobs',
    name: 'manager-review-jobs',
    component: AdminBaseReviewJobs,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
      breadcrumb: function() {
        return 'Review / Jobs';
      },
    },
  },
  {
    path: url_prefix + '/manager/user/review/applications',
    name: 'manager-review-applications',
    component: AdminBaseReviewApplications,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
      breadcrumb: function() {
        return 'Review / Applications';
      },
    },
  }, */
];
